import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for BasicGoalStore, for use in the registry */ export const BasicGoalStoreActionTypes = [
    ActionType.CreateBasicGoalAction,
    ActionType.CreateBasicGoalFailedAction,
    ActionType.CreateBasicGoalSucceededAction,
    ActionType.DeleteBasicGoalAction,
    ActionType.DeleteBasicGoalFailedAction,
    ActionType.DeleteBasicGoalSucceededAction,
    ActionType.FetchBasicGoalsForPlanAction,
    ActionType.FetchBasicGoalsForPlanFailedAction,
    ActionType.FetchBasicGoalsForPlanSucceededAction,
    ActionType.UpdateBasicGoalAction,
    ActionType.UpdateBasicGoalFailedAction,
    ActionType.UpdateBasicGoalSucceededAction
];
